module.exports = __webpack_public_path__ + "static/media/logo_horizontal.7d1e99dc.png";